
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2368_5138)"}},[_c('path',{attrs:{"d":"M10 16H6v-2.342a6.002 6.002 0 01-1.9-1.097l-2.029 1.172-2-3.466L2.1 9.097a6.067 6.067 0 010-2.194L.071 5.733l2-3.466 2.03 1.172A6 6 0 016 2.342V0h4v2.342a6 6 0 011.9 1.097l2.029-1.172 2 3.466-2.029 1.17a6.07 6.07 0 010 2.194l2.029 1.17-2 3.466-2.03-1.172A6 6 0 0110 13.658V16zm-2.667-1.333h1.334v-2.018l.5-.13a4.656 4.656 0 002.162-1.252l.362-.369 1.749 1.01.667-1.155-1.747-1.008.137-.498a4.698 4.698 0 000-2.5l-.137-.497 1.747-1.009-.667-1.154-1.749 1.012-.362-.366a4.656 4.656 0 00-2.162-1.25l-.5-.132V1.333H7.333v2.018l-.5.13A4.656 4.656 0 004.67 4.733l-.362.369L2.56 4.089l-.667 1.155L3.64 6.253l-.137.497a4.699 4.699 0 000 2.5l.137.497-1.747 1.009.667 1.155 1.749-1.01.362.368a4.656 4.656 0 002.162 1.25l.5.13v2.018zm.667-4a2.667 2.667 0 110-5.334 2.667 2.667 0 010 5.334zm0-4a1.333 1.333 0 100 2.666 1.333 1.333 0 000-2.666z","fill":"#0064FF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2368_5138"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    